import React, { Fragment } from 'react'
import { withRouter, Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import NProgress from 'nprogress'
import { Helmet } from 'react-helmet'
import Loader from 'components/LayoutComponents/Loader'
import ErrorBoundary from 'pages/ErrorHandling'
import PublicLayout from './Public'
import LoginLayout from './Login'
import MainLayout from './Main'

const Layouts = {
  public: PublicLayout,
  login: LoginLayout,
  main: MainLayout,
}

@withRouter
@connect(({ user }) => ({ user }))
class IndexLayout extends React.PureComponent {
  previousPath = ''

  componentDidUpdate(prevProps) {
    const { location } = this.props
    const { prevLocation } = prevProps
    if (location !== prevLocation) {
      window.scrollTo(0, 0)
    }
  }

  render() {
    const {
      children,
      location: { pathname, search },
      user,
    } = this.props

    // NProgress Management
    const currentPath = pathname + search
    if (currentPath !== this.previousPath) {
      NProgress.start()
    }

    setTimeout(() => {
      NProgress.done()
      this.previousPath = currentPath
    }, 300)

    // Layout Rendering
    const getLayout = () => {
      // if (pathname === '/' || pathname === '/Jewellery/:articleid' ||  pathname === '/diamonds') {
      //   return 'public'
      // }
      if (pathname === '/' || /^\/enduser(?=\/|$)/i.test(pathname)){
        return 'public'
      }
      if (/^\/user(?=\/|$)/i.test(pathname)) {
        return 'login'
      }
      return 'main'
    }

    const checkLoginRequired = () => {
      if(/^\/enduser(?=\/|$)/i.test(pathname))
      {
        return false
      }
      return true
    }

    const Container = Layouts[getLayout()]
    const isUserAuthorized = user.authorized
    const isUserLoading = user.loading
    const isLoginLayout = getLayout() === 'login'
    const isLoginRequred = checkLoginRequired()

    const BootstrappedLayout = () => {
      // show loader when user in check authorization process, not authorized yet and not on login pages
      if (isUserLoading && !isUserAuthorized && !isLoginLayout) {
        return <Loader />
      }
      if(!isLoginLayout && !isUserAuthorized && !isLoginRequred)
      {
        return <Container>{children}</Container>
      }
      // if (pathname === '/Jewellery/:articleid' || pathname === '/diamonds') {
      //   return <Container>{children}</Container>
      // }
      // redirect to login page if current is not login page and user not authorized
      if (!isLoginLayout && !isUserAuthorized) {
        return <Redirect to="/user/login" />
      }
      // redirect to main dashboard when user on login page and authorized
      if (isLoginLayout && isUserAuthorized) {
        return <Redirect to="/dashboard/alpha" />
      }
      // in other case render previously set layout
      return <Container><ErrorBoundary>{children}</ErrorBoundary></Container>
    }

    return (
      <Fragment>
        <Helmet titleTemplate="Traceable Luxury Solution | %s" title="WebApp" />
        {BootstrappedLayout()}
      </Fragment>
    )
  }
}

export default IndexLayout
